import React from 'react';
import type { LucideIcon } from 'lucide-react';
import StatCard from '../../components/StatCard';

interface AdminStatCardProps {
  label: string;
  value: number | string | undefined;
  icon: LucideIcon;
  loading?: boolean;
}

/**
 * @deprecated Use the standard StatCard (components/StatCard) directly — it now
 * supports {icon, sublabel, loading}. This is a thin compatibility wrapper kept
 * so existing admin consumers keep compiling; do not adopt in new code.
 */
const AdminStatCard: React.FC<AdminStatCardProps> = ({
  label,
  value,
  icon,
  loading = false,
}) => (
  <StatCard label={label} value={value ?? '—'} icon={icon} loading={loading} />
);

export default AdminStatCard;
